import * as React              from 'react';
import { createPortal }        from 'react-dom';
import { useTranslation }      from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import DV                      from 'ts-data-validator';

import TradeStoreSliderIconNext from '../../../components/icons/TradeStoreSliderIconNext';
import TradeStoreSliderIconPrev from '../../../components/icons/TradeStoreSliderIconPrev';

const StoreSlider = function(props) {
  const {
          onClose,
          open,
          slides,
        } = props;

  const { t } = useTranslation();

  const overlayRef = React.useRef(null);
  const sliderRef  = React.useRef(null);

  const [disabled, setDisabled] = React.useState({
    end:   !slides?.length || slides.length === 1,
    start: true,
  });

  React.useEffect(() => {
    overlayRef.current = document.querySelector('.where-buy-slider_overlay');

    if (!overlayRef.current) {
      overlayRef.current = document.createElement('div');

      overlayRef.current.className = 'where-buy-slider_overlay';

      document.body.appendChild(overlayRef.current);
    }

    return () => {
      document.body.removeChild(overlayRef.current);

      setDisabled({
        end: true,
        start: true,
      })
    };
  }, []);
  React.useEffect(() => {
    overlayRef.current?.classList.toggle('open', open);
  }, [open]);
  React.useEffect(() => {
    if (disabled.end !== !slides?.length) {
      setDisabled({
        end:   !slides?.length || slides.length === 1,
        start: true,
      });
    }
  }, [slides?.length]);

  if (!DV.isArray(slides) || !open || !overlayRef.current) {
    return null;
  }

  return createPortal((
    <div
      className={'slider_wrapper'}
      onClick={onClose}
    >
      <Swiper
        autoHeight
        onSlideChange={(swiper) => {
          setDisabled({
            start: swiper.isBeginning,
            end:   swiper.isEnd,
          });
        }}
        onSwiper={(swiper) => {
          sliderRef.current = swiper;
        }}
        slidesPerView={'auto'}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <picture
              className={'slide'}
              key={index}
              onClick={onClose}
            >
              <source
                src={`${slide}.png?h=521&default=horizontal&t=${BUILD_TIME}`}
                type={'image/png'}
              />
              <source
                src={`${slide}.webp?h=521&default=horizontal&t=${BUILD_TIME}`}
                type={'image/webp'}
              />
              <img
                alt={t('field_sliderImage')}
                src={`${slide}.png?default=horizontal&t=${BUILD_TIME}`}
                onClick={(event) => {
                  event.stopPropagation();
                }}
              />
            </picture>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={'action_container'}>
        <TradeStoreSliderIconPrev
          disabled={disabled.start}
          onClick={(event) => {
            event.stopPropagation();

            sliderRef.current?.slidePrev();
          }}
        />
        <TradeStoreSliderIconNext
          disabled={disabled.end}
          onClick={(event) => {
            event.stopPropagation();

            sliderRef.current?.slideNext();
          }}
        />
      </div>
    </div>
  ), overlayRef.current);
};

export default StoreSlider;